import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './counterSlice';
import eventreducer from './eventSlice';
import globalReducer from "../store/reducers/global";


export const store = configureStore({
  reducer: {
    counter: counterReducer,
    event:eventreducer,
    global: globalReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
